export default __webpack_public_path__ + "static/media/6.c9cd4d9e.jpg";